// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-jhs-free-completed[data-v-d3fe497b]{margin-bottom:8.54vw}.c-jhs-free-completed-section01-img[data-v-d3fe497b]{display:block;width:25.6559766764%;margin:0 auto 2.135vw}.c-jhs-free-completed-section02[data-v-d3fe497b]{padding:2.135vw 2.135vw 0}.c-jhs-free-completed-section02 .m-text-comments[data-v-d3fe497b]{font-weight:normal}.c-jhs-free-completed-section03-img[data-v-d3fe497b]{display:block;width:64.139941691%;margin:0 auto 2.135vw}", ""]);
// Exports
module.exports = exports;
